module.exports = __webpack_public_path__ + "img/logo6.12d8e6aa.png";